/** What a page may give every film player below it without importing
 *  three: the renderer to draw with and the animation frames. A page gives
 *  nothing (the player makes three on its canvas and uses the browser's
 *  frames); the ad page's tests give a recorder and a hand-driven clock, as
 *  `Player.test.tsx` does through the props. */
import { createContext } from "react";

import type { FilmRenderer } from "./engine";

export interface FilmEnv {
  createRenderer?: (canvas: HTMLCanvasElement) => FilmRenderer;
  requestFrame?: (cb: (now: number) => void) => number;
  cancelFrame?: (id: number) => void;
}

export const FilmEnvContext = createContext<FilmEnv | null>(null);
